import axios, { AxiosInstance } from 'axios'

export const wordpressClient: AxiosInstance = axios.create({
  baseURL: 'https://cms.fightback-wrestling.com/wp-json/wp/v2',
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
})

const API_KEY = `${process.env.REACT_APP_YOUTUBE_API_KEY}`
const CHANNEL_ID = `${process.env.REACT_APP_YOUTUBE_CHANNEL_ID}`

// Note: we deliberately do NOT use the /search endpoint here.
// YouTube's search.list results are served from a search index that can lag
// behind real uploads by hours or even days, which made new uploads "invisible"
// on the homepage. Fetching the channel's uploads playlist via
// channels.list -> playlistItems.list reflects new uploads immediately.
export const youTubeChannelClient: AxiosInstance = axios.create({
  baseURL: 'https://www.googleapis.com/youtube/v3/channels',
  params: {
    key: API_KEY,
    id: CHANNEL_ID,
    part: 'contentDetails',
  },
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
})

export const youTubePlaylistItemsClient: AxiosInstance = axios.create({
  baseURL: 'https://www.googleapis.com/youtube/v3/playlistItems',
  params: {
    key: API_KEY,
    part: 'snippet,contentDetails',
    maxResults: 4,
  },
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
})

export const emailClient: AxiosInstance = axios.create({
  baseURL: 'https://nnhc3drseuemiq55hnlsuiny240dwvou.lambda-url.eu-central-1.on.aws/',
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
})
